import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export function CookieTab({ content, setContent }) {
  const config = content.cookie_consent || {};

  const update = (field, value) => {
    setContent(prev => ({
      ...prev,
      cookie_consent: { ...prev.cookie_consent, [field]: value },
    }));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cookie Consent</CardTitle>
        <CardDescription>Configure the cookie compliance banner shown to visitors</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Enable / Disable */}
        <div className="flex items-center justify-between">
          <div>
            <Label className="text-base font-semibold">Enable Cookie Banner</Label>
            <p className="text-sm text-gray-500">Show cookie consent banner to visitors</p>
          </div>
          <Switch
            checked={config.enabled !== false}
            onCheckedChange={(checked) => update('enabled', checked)}
            data-testid="cookie-enabled-toggle"
          />
        </div>

        {/* Position */}
        <div>
          <Label>Banner Position</Label>
          <Select value={config.position || 'bottom'} onValueChange={(val) => update('position', val)}>
            <SelectTrigger data-testid="cookie-position-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="bottom">Bottom of screen</SelectItem>
              <SelectItem value="top">Top of screen</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Reset Period */}
        <div>
          <Label>Consent Reset Period</Label>
          <p className="text-sm text-gray-500 mb-2">How often the banner re-appears after a visitor makes a choice</p>
          <Select value={String(config.reset_days || '90')} onValueChange={(val) => update('reset_days', val)}>
            <SelectTrigger data-testid="cookie-reset-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="30">30 days</SelectItem>
              <SelectItem value="60">60 days</SelectItem>
              <SelectItem value="90">90 days</SelectItem>
              <SelectItem value="180">180 days</SelectItem>
              <SelectItem value="365">1 year</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Text Customization */}
        <div className="space-y-4">
          <Label className="text-base font-semibold block">Banner Text</Label>
          <div>
            <Label>Heading</Label>
            <Input
              value={config.heading || ''}
              onChange={(e) => update('heading', e.target.value)}
              placeholder="We value your privacy"
              data-testid="cookie-heading-input"
            />
          </div>
          <div>
            <Label>Description</Label>
            <Input
              value={config.description || ''}
              onChange={(e) => update('description', e.target.value)}
              placeholder="We use cookies to enhance your browsing experience and analyse our traffic."
              data-testid="cookie-description-input"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
